import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  alertOpen: false,
  demoProgression: {
    progressionActive: false,
    intervalSeconds: 5,
    manualDemoTrigger: false,
  },
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    openAlert(state) {
      state.alertOpen = true;
    },
    setProgressionActive(state, action) {
      state.demoProgression.progressionActive = action.payload;
    },
    setIntervalSeconds(state, action) {
      state.demoProgression.intervalSeconds = action.payload;
    },
    setManualDemoTrigger(state, action) {
      state.demoProgression.manualDemoTrigger = action.payload;
    },
  },
});

export const {
  openAlert,
  setProgressionActive,
  setIntervalSeconds,
  setManualDemoTrigger,
} = settingsSlice.actions;
export default settingsSlice.reducer;
